import type { FichaCata } from '@escuela/ficha-domain'

/** Devuelve una copia de `obj` con `value` seteado en `path` (dot-path). */
export function setByPath<T>(obj: T, path: string, value: unknown): T {
  const keys = path.split('.')
  const root = Array.isArray(obj) ? [...obj] : { ...(obj as object) }
  let cursor = root as Record<string, unknown>
  for (let i = 0; i < keys.length - 1; i += 1) {
    const key = keys[i]!
    const current = cursor[key]
    cursor[key] =
      current && typeof current === 'object'
        ? Array.isArray(current)
          ? [...current]
          : { ...current }
        : {}
    cursor = cursor[key] as Record<string, unknown>
  }
  cursor[keys[keys.length - 1]!] = value
  return root as T
}

/**
 * Path del campo de texto libre "otros" hermano de un multi-choice/cepa, o null
 * si el campo no tiene uno. Ver specs/docente-fichas.md "Mapeo de controles".
 */
export function otrosPathFor(path: string): string | null {
  if (path.endsWith('.seleccion')) {
    return `${path.slice(0, -'.seleccion'.length)}.otro`
  }
  if (path === 'conclusiones.vinificacionEstilo') return 'conclusiones.vinificacionOtro'
  if (path === 'conclusiones.variedadUvas') return 'conclusiones.variedadUvaOtros'
  if (path.endsWith('Complementario')) return `${path}Otro`
  return null
}

/**
 * Aplica los resets en cascada que dispara cambiar un campo segmented, para
 * mantener paridad con el form de la app (los dependientes ocultos se limpian).
 */
export function applyDependentResets(
  ficha: FichaCata,
  path: string,
): FichaCata {
  let next = ficha
  switch (path) {
    case 'apariencia.colorPrincipal':
      next = setByPath(next, 'apariencia.colorInterior', '')
      break
    case 'conclusiones.vinificacionCategoria':
      next = setByPath(next, 'conclusiones.vinificacionEstilo', [])
      next = setByPath(next, 'conclusiones.vinificacionOtro', '')
      break
    case 'gusto.co2':
      next = setByPath(next, 'gusto.co2Intensidad', '')
      break
    case 'conclusiones.potencialGuarda':
      next = setByPath(next, 'conclusiones.potencialGuardaOtro', '')
      break
    case 'nariz.limpioDefectuoso':
      next = setByPath(next, 'nariz.defectos', { seleccion: [], otro: '' })
      break
    case 'gusto.limpioDefectuoso':
      next = setByPath(next, 'gusto.defectos', { seleccion: [], otro: '' })
      break
    default:
      break
  }
  return next
}
